// Custom stream actions, see https://marcoroth.dev/posts/guide-to-custom-turbo-stream-actions
import { StreamActions } from "@hotwired/turbo"
import * as bootstrap from "bootstrap"
 
StreamActions.log_to_console = function() {
  const message = this.getAttribute("message")
  console.log(message)
}

StreamActions.show_modal = function() {
  const modal_container_id = (this.getAttribute("modal_id") || 'modal_container');
  const modal_container= document.getElementById(modal_container_id);
  
  if (modal_container) {
    // De modal popup zit binnen een modal container
    const modalElm= modal_container.firstElementChild;
    const modalOptions={};
    
    if (modalElm) {
      // console.log(`Activating modal window ${modalElm.id}`);
      let modal = bootstrap.Modal.getOrCreateInstance(modalElm, modalOptions);
      if (modal) {
        // Remove any lost backdrop due to modal overlapping
        const bdElm= document.querySelector('aside.popups + .modal-backdrop.show');
        if (bdElm) bdElm.remove();

        modalElm.addEventListener('shown.bs.modal', event => {
          // Set focus on first form field when modal is shown
          const firstInputElm= modalElm.querySelector('form *[autofocus]');
          if (firstInputElm) firstInputElm.focus();

        })

        modal.show();
      }
    }
  }
}

StreamActions.close_modal = function() {
  const modal_container_id = '#' + (this.getAttribute("modal_id") || 'modal_container');
  const modal_container= document.querySelector(modal_container_id);
  
  if (modal_container) {
    // De modal popup zit binnen een modal container
    const modalElm= modal_container.firstElementChild;

    // Zoek de echte modal
    const modal = bootstrap.Modal.getInstance(modalElm);
    if (modal) {
      // Verberg/verwijder de modal
      modal.hide();
      // Verwijder ook de modal HTML
      modalElm.remove();
    }
  }
}

StreamActions.refresh_page = function() {
  const path= this.getAttribute("path")

  if (path) {
    location= path;
  } else {
    location.reload();
  }
}

// Set focus on specified element by selector
StreamActions.focus = function() {
  const selector = this.getAttribute("selector")
  const focusElm= document.querySelector(selector);
  if (focusElm) focusElm.focus({ focusVisible: true });
}
